<template>
  <NuxtLayout>
    <NuxtPage />
  </NuxtLayout>
</template>

<script setup lang="ts">
import { useI18n } from '#i18n'

const { locale } = useI18n()

watch(locale, (newLocale) => {
  useHead({
    htmlAttrs: {
      dir: newLocale === 'fa' ? 'rtl' : 'ltr',
      lang: newLocale
    }
  })
}, { immediate: true })
</script>
